module.exports = function(h, row) {
    if (_.isEmpty(row.available_to)) {
        return <i>No time assigned</i>;
    } else {
        return moment(row.available_to, 'HH:mm:ss').format('h:mm A');
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/tag/colums/available_to.jsx